import { CmsObjectWithDefault } from '@components/Cms/types';

export type SocialLoginFormCmsKey =
    | 'technicalDifficulty'
    | 'youAreSuccessfullyLoggedIn'
    | 'youAreNotAllowedToLogIn'
    | 'pleaseTryAgain'
    | 'invalidOtpCode'
    | 'phoneAlreadyExist';

export const SocialLoginFormCmsWithDefault: CmsObjectWithDefault<SocialLoginFormCmsKey> = {
    technicalDifficulty: {
        cmsId: 101793,
        defaultTranslation: 'We are currently experiencing technical difficulties.',
    },
    youAreSuccessfullyLoggedIn: {
        cmsId: 115055,
        defaultTranslation: 'You are successfully logged in.',
    },
    youAreNotAllowedToLogIn: {
        cmsId: 115056,
        defaultTranslation: 'You are not allowed to log in.',
    },
    pleaseTryAgain: {
        cmsId: 269092,
        defaultTranslation: 'Sorry, we have encountered a technical issue. Please try again.',
    },
    invalidOtpCode: {
        cmsId: 97933,
        defaultTranslation: 'The OTP code is incorrect. Please re-enter or request a new OTP.',
    },
    phoneAlreadyExist: {
        cmsId: 83203,
        defaultTranslation: 'Please use another mobile number.',
    },
};
